import restApiClient from "@/api/clients/restApiClient";

export const restApi = restApiClient;
